export const CLIENT_URL = process.env.REACT_APP_CLIENT_URL || '';

export const SERVER_URL =
	process.env.REACT_APP_SERVER_URL || 'http://localhost';

export const IMAGE_SERVER_URL =
	`${process.env.REACT_APP_SERVER_URL}` || 'http://localhost:5001';

export const API_URL = `${process.env.REACT_APP_SERVER_URL}:${
	process.env.REACT_APP_SERVER_PORT || 5001
}/api/v1/`;
